import { LeaveApprovalType, LeaveStatus } from 'models/enums';

export interface LeaveApprovalLike {
  status: number;
  comments?: string | null;
  approvalType?: number;
}

export function getApprovalStatusLabel(approval: {
  status: number;
  approvalType?: number;
}): string {
  const isCancellation =
    approval.approvalType === LeaveApprovalType.CANCELLATION;

  if (approval.status === LeaveStatus.APPROVED) {
    return isCancellation ? 'Cancellation approved' : 'Approved';
  }
  if (approval.status === LeaveStatus.REJECTED) {
    return isCancellation ? 'Cancellation rejected' : 'Rejected';
  }
  if (approval.status === LeaveStatus.PENDING) {
    return isCancellation ? 'Cancellation pending' : 'Pending';
  }
  return 'Unknown';
}

export function getApprovalStatusClassName(approval: {
  status: number;
  approvalType?: number;
}): string {
  const isCancellation =
    approval.approvalType === LeaveApprovalType.CANCELLATION;

  return `approval-status approval-status-${approval.status}${
    isCancellation ? ' approval-status-cancellation' : ''
  }`;
}

export function getRespondPageBadgeClassName(approval: {
  status: number;
  approvalType?: number;
}): string {
  const isCancellation =
    approval.approvalType === LeaveApprovalType.CANCELLATION;

  if (approval.status === LeaveStatus.APPROVED) {
    return isCancellation
      ? 'status-badge cancellation-approved'
      : 'status-badge approved';
  }
  if (approval.status === LeaveStatus.REJECTED) {
    return isCancellation
      ? 'status-badge cancellation-rejected'
      : 'status-badge rejected';
  }
  if (approval.status === LeaveStatus.PENDING) {
    return isCancellation
      ? 'status-badge cancellation-pending'
      : 'status-badge pending';
  }
  return 'status-badge';
}

/** Show only real approver decisions — hide pending and superseded rows. */
export function getMeaningfulApprovals<T extends LeaveApprovalLike>(
  approvals: T[]
): T[] {
  return approvals.filter((approval) => {
    if (approval.status === 0) return false;
    if (
      approval.status === 2 &&
      approval.comments?.toLowerCase().includes('superseded')
    ) {
      return false;
    }
    return true;
  });
}
